import { jsx as _jsx } from "react/jsx-runtime";
import { getPercentageDifferenceForPeriod } from '../getPercentageDifferenceForPeriod';
const InstrumentPercentageChangeComponent = ({ className, periodicExchangeRatesData, instrumentIso, period, reverseExchangeRates, }) => {
    const difference = getPercentageDifferenceForPeriod(periodicExchangeRatesData, instrumentIso, period, reverseExchangeRates);
    const isPositive = (difference || 0) > 0;
    const isNegative = (difference || 0) < 0;
    const formatted = (difference === null) ? '-' : `${isPositive ? '+' : ''}${difference.toFixed(2)}%`;
    return (_jsx("div", { className: className, style: { color: isPositive ? 'green' : isNegative ? 'red' : undefined }, children: formatted }));
};
export default InstrumentPercentageChangeComponent;
